/**
 * A/B de copy del asistente: asignación estable por pestaña (sessionStorage).
 */

const STORAGE_PREFIX = 'soluqr_ab_v1_';

/**
 * @template {{ id: string, text: string }} T
 * @param {string} key
 * @param {T[]} variants
 * @returns {T}
 */
export function pickVariant(key, variants) {
  if (!key || !Array.isArray(variants) || variants.length === 0) {
    return /** @type {T} */ ({ id: 'A', text: '' });
  }
  const sk = STORAGE_PREFIX + key;
  try {
    if (typeof sessionStorage !== 'undefined') {
      const stored = sessionStorage.getItem(sk);
      if (stored) {
        const found = variants.find((v) => String(v.id) === String(stored));
        if (found) return { ...found };
      }
      const i = Math.floor(Math.random() * variants.length);
      const chosen = variants[i];
      sessionStorage.setItem(sk, String(chosen.id));
      return { ...chosen };
    }
  } catch {
    /* private mode / quota */
  }
  return { ...variants[0] };
}

/**
 * @param {string} key
 * @returns {string|null}
 */
export function readAbVariantId(key) {
  if (!key || typeof sessionStorage === 'undefined') return null;
  try {
    return sessionStorage.getItem(STORAGE_PREFIX + key);
  } catch {
    return null;
  }
}

/** Definiciones centralizadas (mismo orden de ids A/B). */
export const AB_RECOMMENDATION_COPY = [
  { id: 'A', text: '¿Querés que te recomiende algo?' },
  { id: 'B', text: 'Lo más pedido por acá es esto 👇' },
];

export const AB_NUDGE_DEFAULT_COPY = [
  { id: 'A', text: '¿Te ayudo a elegir o querés ver más opciones?' },
  { id: 'B', text: '¿Querés ver lo más pedido o algo que combine con tu pedido?' },
];

export const AB_CLOSING_COPY = [
  { id: 'A', text: '¿Vamos al carrito o querés agregar algo más?' },
  { id: 'B', text: 'Ya casi está listo 👇 revisá tu pedido y confirmá' },
];
